// extracted by css-extract-rspack-plugin
export default {"headerPrimary":"_7a000926","reviews":"_79e7c7c","location":"_f67ab9c8","imageContainer":"_d4f06155","compact":"_3dd84d52","pillAlign":"_90ec2da1"};